module.exports = __webpack_public_path__ + "static/media/s_value.9383d7c8.png";